import { render, staticRenderFns } from "./amount.vue?vue&type=template&id=4601355d&scoped=true"
import script from "./amount.vue?vue&type=script&lang=js"
export * from "./amount.vue?vue&type=script&lang=js"
import style0 from "./amount.vue?vue&type=style&index=0&id=4601355d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4601355d",
  null
  
)

export default component.exports